'use client';

import { useLocale, useTranslations } from 'next-intl';
import { useMemo } from 'react';

import type { SelectOptionProps, SingleSelectValueProps } from '@hrworks/sui-core/Select';
import { Select } from '@hrworks/sui-core/Select';

import countries from './countries.json';

type CountrySelectProps = SingleSelectValueProps & {
  name: string;
  label: string;
  'aria-label'?: string;
  placeholder?: string;
  mandatory?: boolean;
  labelPlacement?: 'floating' | 'inside';
  validationMessage?: string;
  validationState?: 'success' | 'warning' | 'danger';
};

export const CountrySelect = ({ defaultValue = 'DEU', ...props }: CountrySelectProps) => {
  const t = useTranslations('Countries');
  const locale = useLocale();

  const countryOptions: SelectOptionProps[] = useMemo(
    () =>
      countries
        .map((country) => ({
          label: t.has(country['alpha-3'] as Parameters<typeof t>[0])
            ? t(country['alpha-3'] as Parameters<typeof t>[0])
            : country.name,
          value: country['alpha-3'],
        }))
        .sort((a, b) => a.label.localeCompare(b.label, locale)),
    [t, locale],
  );

  return <Select options={countryOptions} defaultValue={defaultValue} {...props} />;
};
